import { ethers } from "ethers";
// import dotenv from "dotenv";
import pinataSDK from "@pinata/sdk";
import fs from "fs";
import { getContracts } from "../utils/getContracts";
import pinJSONToIPFS from "@pinata/sdk/types/commands/pinning/pinJSONToIPFS";
import {

  getPlantRecordedTimestamps,

  getPlantRecordedEvents,

} from "../utils/eventCache";

 
// dotenv.config();
 
const { REACT_APP_pinataJWT } = process.env;
 
const pinata = new pinataSDK({
  pinataJWTKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI2NDgyZjkxZS0zNjNlLTQ5OWYtYjQ1ZC0wNzNmYzA4NmQxYTUiLCJlbWFpbCI6InRlaGlsYWZhdm91cml0ZUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiNTczMGRiYjgwNjhiZjFjYjdkYTUiLCJzY29wZWRLZXlTZWNyZXQiOiI1MTkyMmJmNDM1ZGUwYWM5YWMwN2UzYmE4NzQ1OGZiYzU5N2FjOTI3MzJhOTJjMGFlNjQyYmQ1OWNhZWRkMzk4IiwiaWF0IjoxNzAwMjA4NzQzfQ.t850Nq1NQGZTnpw-f-NEhVUrk892-UBFUWOp6hkiqnk",
});
const abiCoder = new ethers.AbiCoder();
 
function encodeStaticData(
  OrganizationDescription: string,
  location: string,
  personResponsible: string,
  descriptionOfRenewableEnergySources: string,
  baseline: number
): string {
  const encodedStaticAttributes = abiCoder.encode(
    ["string", "string", "string", "string", "uint256"],
    [
      OrganizationDescription,
      location,
      personResponsible,
      descriptionOfRenewableEnergySources,
      baseline,
    ]
  );
  // console.log(encodedStaticAttributes);
  return encodedStaticAttributes;
}
 
/**** For Backend ****/
 
function encodedDynamicAttributes(
  reportingPeriod: string,
  energyConsumptionInKWh: number,
  quantifiedGHGEmissionsInBaselineScenario: number,
  totalGHGEmission: number
): any {
  const convertedEnergyConsumptionInKWh = ethers.parseEther(
    energyConsumptionInKWh.toString()
  );
  const convertedQuantifiedGHGEmissionsInBaselineScenario =
    ethers.parseEther(
      quantifiedGHGEmissionsInBaselineScenario.toString()
    );
  const convertedTotalGHGEmission = ethers.parseEther(
    totalGHGEmission.toString()
  );
 
  const encodedDynamicAttributes = abiCoder.encode(
    ["string", "uint256", "uint256", "uint256"],
    [
      reportingPeriod,
      convertedEnergyConsumptionInKWh,
      convertedQuantifiedGHGEmissionsInBaselineScenario,
      convertedTotalGHGEmission,
    ]
  );
  // console.log(encodedDynamicAttributes);
 
  return encodedDynamicAttributes;
}
 
/**** For Backend ****/
 
async function pinLinksToIPFS(link: string[]) {
  let links: any;
 
  links = {
    link: link,
  };
 
  let options: any;
  options = {
    pinataMetadata: {
      name: "Netzence",
      keyvalues: {
        customKey: "Netzence",
        customKey2: "Netzence",
      },
    },
    pinataOptions: {
      cidVersion: 0,
    },
  };
  console.log(links);
  const result = await pinata.pinJSONToIPFS(links, options);
  console.log(result);
  return result;
}
 
// async function grantRole(role: number, addressToGrant: string) {
//   const { signer, basicGreenContractInstance } = await getContracts();
//   const VALIDATOR_ROLE = await basicGreenContractInstance.VALIDATOR_ROLE();
//   const MASTER_NODE = await basicGreenContractInstance.MASTER_NODE();
//   let roleToGrant;
//   switch (role) {
//     case 1:
//       roleToGrant = VALIDATOR_ROLE;
//       break;
//     case 2:
//       roleToGrant = MASTER_NODE;
//       break;
//     default:
//       throw new Error("Invalid role");
//   }
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .grantRole(roleToGrant, addressToGrant, true);
//   return {
//     tx,
//   };
// }
 
// async function performKYC(
//   addressToRecord: string,
//   bytesEncodedStaticAttributes: string,
//   Name: string,
//   Scenario: string
// ) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const txKYC = await basicGreenContractInstance
//     .connect(signer)
//     .performKYC(addressToRecord, bytesEncodedStaticAttributes, Name, Scenario);
//   return {
//     txKYC,
//   };
// }
 
// async function recordPlant(
//   addressToRecord: string[],
//   bytesDynamicAttributes: string[]
// ) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .recordPlant(addressToRecord, bytesDynamicAttributes);
//   return {
//     tx,
//   };
// }
 
// async function rejectValidation(addressToReject: string) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .rejectValidation(addressToReject);
//   return {
//     tx,
//   };
// }
 
// async function validate(addressToValidate: string) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .validate(addressToValidate);
//   return {
//     tx,
//   };
// }
 
// async function verifyAndMint(addressToVerify: string) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .verifyAndMint(addressToVerify);
//   return {
//     tx,
//   };
// }
 
async function conditions(address: string, index: number) {
  const { basicGreenContractInstance } = await getContracts();
 
  const conditions = await basicGreenContractInstance.conditions(
    address,
    index
  );
  return {
    isValidated: conditions.isValidated,
    isVerified: conditions.isVerified,
    isRejected: conditions.isRejected,
    isCarbonCreditIssued: conditions.isCarbonCreditIssued,
  };
}
 
// async function issueCarbonCredits(address: string) {
//   const { signer, basicGreenContractInstance } = await getContracts();
 
//   const tx = await basicGreenContractInstance
//     .connect(signer)
//     .issueCarbonCredits(address);
//   return {
//     tx,
//   };
// }
 
async function getAllEmissionValues(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const allEmissionValues =
    await basicGreenContractInstance.allEmissionValues(address);
  return {
    energyConsumptionInKWh: ethers.formatEther(
      allEmissionValues.energyConsumptionInKWh.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      allEmissionValues.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    reportingPeriod: allEmissionValues.reportingPeriod,
 
    totalGHGEmission: ethers.formatEther(
      allEmissionValues.totalGHGEmission.toString()
    ),
  };
}



async function userEmission(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  // Get the length of emission data for the user
  const emissionDataLength: number = await basicGreenContractInstance.getAllPlantEmissionLength(
    address
  );
 
  console.log('emissionDataLength', emissionDataLength);
  

  // Retrieve all emission data for the user
  const allEmissionData: any[] = [];
 
  for (let i = 0; i < emissionDataLength; i++) {
    const allEmission = await basicGreenContractInstance.allEmission(
      address,
      i
    );
    
    

    allEmissionData.push({
      energyConsumptionInKWh: ethers.formatEther(
        allEmission.energyConsumptionInKWh.toString()
      ),
      quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
        allEmission.quantifiedGHGEmissionsInBaselineScenario.toString()
      ),
      reportingPeriod: allEmission.reportingPeriod,
      totalGHGEmission: ethers.formatEther(
        allEmission.totalGHGEmission.toString()
      ),
      isVerified: allEmission.isVerified,
    });
  }
 
  return allEmissionData;
}
 
async function allEmission(address: string, index: number) {
  const { basicGreenContractInstance } = await getContracts();
  const allEmission = await basicGreenContractInstance.allEmission(
    address,
    index
  );
  return {
    reportingPeriod: allEmission.reportingPeriod,
    energyConsumptionInKWh: ethers.formatEther(
      allEmission.energyConsumptionInKWh.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      allEmission.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    totalGHGEmission: ethers.formatEther(
      allEmission.totalGHGEmission.toString()
    ),
    isVerified: allEmission.isVerified,
  };
}
 
 
 
// first code
// async function getThreeMonthUnverifiedAccumulations(plantAddress: string) {
//   try {
//     const { basicGreenContractInstance } = await getContracts();
 
//     const emissionData = await basicGreenContractInstance.getPlantEmissionData(
//       plantAddress
//     );
 
//     // Query PlantRecorded events to get timestamps mapped by original index
//     let eventTimestamps: any[] = [];
//     try {
//       const filter =
//         basicGreenContractInstance.filters.PlantRecorded(plantAddress);
//       const events = await basicGreenContractInstance.queryFilter(filter);
//       events.sort((a: any, b: any) => {
//         if (a.blockNumber !== b.blockNumber)
//           return a.blockNumber - b.blockNumber;
//         return a.logIndex - b.logIndex;
//       });
//       eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
//     } catch (e) {
//       eventTimestamps = [];
//     }
 
//     // find first unverified emission index
//     let firstIdx: number | null = null;
//     for (let i = 0; i < emissionData.length; i++) {
//       if (!emissionData[i].isVerified) {
//         firstIdx = i;
//         break;
//       }
//     }
 
//     if (firstIdx === null) {
//       // nothing to accumulate
//       return {
//         energyConsumptionInKWh: "0.00",
//         totalGHGEmission: "0.00",
//         quantifiedGHGEmissionsInBaselineScenario: "0.00",
//       };
//     }
 
//     // helper to convert a timestamp (BigInt/number/string) to seconds (number)
//     function toSeconds(ts: any): number | null {
//       if (ts === undefined || ts === null) return null;
//       let n: number;
//       try {
//         // Handle BigInt in ethers v6
//         if (typeof ts === 'bigint') {
//           n = Number(ts);
//         } else if (typeof ts === "object" && typeof ts.toNumber === "function") {
//           n = ts.toNumber();
//         } else {
//           n = Number(ts);
//         }
//       } catch (e) {
//         return null;
//       }
//       if (Number.isNaN(n)) return null;
//       if (n > 1e12) return Math.floor(n / 1000);
//       return Math.floor(n);
//     }
 
//     const startTs = toSeconds(
//       eventTimestamps[firstIdx] ??
//         emissionData[firstIdx].timestamp ??
//         emissionData[firstIdx].issuedTime ??
//         null
//     );
//     if (startTs === null) {
//       // can't determine start time; return zeros
//       return {
//         energyConsumptionInKWh: "0.00",
//         totalGHGEmission: "0.00",
//         quantifiedGHGEmissionsInBaselineScenario: "0.00",
//         facilityCapacity: "0.00",
//         rangeStartDate: null,
//         rangeEndDate: null,
//         reportingPeriod: null,
//         facilityName: null,
//       };
//     }
 
//     const windowSeconds = 90 * 24 * 60 * 60; // 90 days
//     const windowEnd = startTs + windowSeconds;
 
//     // use BigInt sums to avoid precision loss (ethers v6 uses native BigInt)
//     let energySum = BigInt(0);
//     let totalGHGSum = BigInt(0);
//     let quantifiedGHGSum = BigInt(0);
 
//     for (let i = 0; i < emissionData.length; i++) {
//       const emission: any = emissionData[i];
//       if (emission.isVerified) continue;
 
//       const ts = toSeconds(
//         eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null
//       );
//       if (ts === null) continue;
//       if (ts < startTs || ts > windowEnd) continue;
 
//       // emission fields are uint256 (wei-like) so sum them as BigInts
//       try {
//         energySum = energySum + BigInt(emission.energyConsumptionInKWh.toString());
//       } catch (e) {
//         console.error('Error adding energyConsumptionInKWh:', e);
//       }
//       try {
//         totalGHGSum = totalGHGSum + BigInt(emission.totalGHGEmission.toString());
//       } catch (e) {
//         console.error('Error adding totalGHGEmission:', e);
//       }
//       try {
//         quantifiedGHGSum = quantifiedGHGSum + BigInt(emission.quantifiedGHGEmissionsInBaselineScenario.toString());
//       } catch (e) {
//         console.error('Error adding quantifiedGHGEmissionsInBaselineScenario:', e);
//       }
//     }
 
//     // retrieve facility capacity and plant name/reportingPeriod
//     let facilityCapacityFormatted = "0.00";
//     let facilityName: string | null = null;
//     let reportingPeriod: string | null = null;
 
//     try {
//       const plantInfoRaw = await basicGreenContractInstance.plantInfo(
//         plantAddress
//       );
//       facilityName = plantInfoRaw.organizationName || null;
//     } catch (e) {
//       facilityName = null;
//     }
 
//     try {
//       const allEmissionVals =
//         await basicGreenContractInstance.allEmissionValues(plantAddress);
//       try {
//         // Primary: expect a BigInt value (wei-style) and format it
//         let capFormatted = "0.00";
//         try {
//           capFormatted = Number(
//             ethers.formatEther(allEmissionVals.facilityCapacity)
//           ).toFixed(2);
//         } catch (innerErr) {
//           // If it's not BigInt, maybe it's already a human-readable string/number
//           if (
//             allEmissionVals.facilityCapacity !== undefined &&
//             allEmissionVals.facilityCapacity !== null
//           ) {
//             const asNum = Number(allEmissionVals.facilityCapacity);
//             if (!Number.isNaN(asNum) && asNum !== 0) {
//               capFormatted = asNum.toFixed(2);
//             } else {
//               capFormatted = "0.00";
//             }
//           }
//         }
//         facilityCapacityFormatted = capFormatted;
//       } catch (e) {
//         facilityCapacityFormatted = "0.00";
//       }
//     } catch (e) {
//       facilityCapacityFormatted = "0.00";
//     }
 
//     // If aggregated facilityCapacity is still zero, try falling back to the
//     // per-emission capacity stored on the first unverified emission (if present).
//     if (facilityCapacityFormatted === "0.00") {
//       try {
//         const perEmissionCap = emissionData[firstIdx].facilityCapacity;
//         if (perEmissionCap !== undefined && perEmissionCap !== null) {
//           facilityCapacityFormatted = Number(
//             ethers.formatEther(perEmissionCap)
//           ).toFixed(2);
//         }
//       } catch (e) {
//         // keep as "0.00" if fallback fails
//       }
//     }
 
//     // reportingPeriod from first unverified emission (if exists)
//     reportingPeriod = emissionData[firstIdx].reportingPeriod ?? null;
 
//     const rangeStartDate = formatDate(new Date(startTs * 1000));
//     const rangeEndDate = formatDate(new Date(windowEnd * 1000));
 
//     return {
//       energyConsumptionInKWh: Number(
//         ethers.formatEther(energySum)
//       ).toFixed(2),
//       totalGHGEmission: Number(ethers.formatEther(totalGHGSum)).toFixed(2),
//       quantifiedGHGEmissionsInBaselineScenario: Number(
//         ethers.formatEther(quantifiedGHGSum)
//       ).toFixed(2),
//       facilityCapacity: facilityCapacityFormatted,
//       rangeStartDate,
//       rangeEndDate,
//       reportingPeriod,
//       facilityName,
//     };
//   } catch (error: any) {
//     console.error("Error getting 3-month unverified accumulations:", error);
//     return {
//       error: error.message || "Unknown error occurred",
//     };
//   }
// }
// // Helper function to format date as DD/MM/YYYY
// function formatDate(date: Date): string {
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}/${month}/${year}`;
// }
 
// latest code for three-month accumulations
// Paged version: compute three-month accumulations for a page of plants.
// Returns a map keyed by plantAddress with the accumulation object for each plant
async function getThreeMonthUnverifiedAccumulations(
  start: number,
  count: number
) {
  try {
    const { basicGreenContractInstance } = await getContracts();
 
    // fetch the plants page from the contract
    const plantsData = await basicGreenContractInstance.getPlantsData(
      start,
      count
    );
 
    // compute accumulations in parallel per plant (bounded by page size)
    const promises = plantsData.map((p: any) =>
      getThreeMonthUnverifiedAccumulationsForPlant(p.plantAddress).catch(
        (e) => ({ error: String(e) })
      )
    );
 
    const results = await Promise.all(promises);
    const map: Record<string, any> = {};
    for (let i = 0; i < plantsData.length; i++) {
      const addr = plantsData[i].plantAddress;
      map[addr] = results[i];
    }
 
    return map;
  } catch (error: any) {
    console.error("Error getting 3-month accumulations for page:", error);
    return {};
  }
}
 
// Compute three-month accumulations for ALL plants by paging through all
// registered plants and aggregating page results. Returns a map keyed by plantAddress.
// async function getThreeMonthUnverifiedAccumulationsAll(pageSize = 50) {
//   try {
//     const { basicGreenContractInstance } = await getContracts();

//     const totalBN: any = await basicGreenContractInstance.getAllPlantsLength();
//     const total = typeof totalBN.toNumber === "function" ? totalBN.toNumber() : Number(totalBN);
//     const resultMap: Record<string, any> = {};

//     for (let start = 0; start < total; start += pageSize) {
//       const count = Math.min(pageSize, total - start);
//       const pageMap = await getThreeMonthUnverifiedAccumulations(start, count);
//       for (const addr of Object.keys(pageMap)) {
//         resultMap[addr] = pageMap[addr];
//       }
//     }

//     return resultMap;
//   } catch (error: any) {
//     console.error("Error getting 3-month accumulations for all plants:", error);
//     return {};
//   }
// }

async function getThreeMonthUnverifiedAccumulationsAll(pageSize = 50) {
  try {
    const { basicGreenContractInstance } = await getContracts();

    // Get total plants count
    const totalBN = await basicGreenContractInstance.getAllPlantsLength();
    const total = typeof totalBN.toNumber === "function" 
      ? totalBN.toNumber() 
      : Number(totalBN);

    if (total === 0) {
      return {};
    }

    // Build all page requests for parallel execution
    const pageRequests = [];
    for (let start = 0; start < total; start += pageSize) {
      const count = Math.min(pageSize, total - start);
      pageRequests.push(getThreeMonthUnverifiedAccumulations(start, count));
    }

    // Execute all page requests in parallel with settled handling
    const pageResults = await Promise.allSettled(pageRequests);
    
    // Merge results from all successful pages
    const resultMap: Record<string, any> = {};
    let failedPages = 0;
    
    for (const result of pageResults) {
      if (result.status === 'fulfilled') {
        const pageMap = result.value;
        for (const addr of Object.keys(pageMap)) {
          resultMap[addr] = pageMap[addr];
        }
      } else {
        failedPages++;
        console.warn(
          `Page request failed: ${result.reason?.message || result.reason}`
        );
      }
    }

    if (failedPages > 0) {
      console.warn(
        `getThreeMonthUnverifiedAccumulationsAll: ${failedPages} page(s) failed to load`
      );
    }

    return resultMap;
  } catch (error: any) {
    console.error("Error getting 3-month accumulations for all plants:", error);
    return {};
  }
}
// Returns accumulated unverified totals for the next three months (90 days)
// starting from the first unverified emission for the given plant.
async function getThreeMonthUnverifiedAccumulationsForPlant(
  plantAddress: string
) {
  try {
    const { basicGreenContractInstance } = await getContracts();
 
    const emissionData = await basicGreenContractInstance.getPlantEmissionData(
      plantAddress
    );
 
    // Query PlantRecorded events to get timestamps mapped by original index
    let eventTimestamps: any[] = [];
    try {
      const filter =
        basicGreenContractInstance.filters.PlantRecorded(plantAddress);
      const events = await basicGreenContractInstance.queryFilter(filter);
      events.sort((a: any, b: any) => {
        if (a.blockNumber !== b.blockNumber)
          return a.blockNumber - b.blockNumber;
        return a.logIndex - b.logIndex;
      });
      eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
    } catch (e) {
      eventTimestamps = [];
    }
 
    // find first unverified emission index
    let firstIdx: number | null = null;
    for (let i = 0; i < emissionData.length; i++) {
      if (!emissionData[i].isVerified) {
        firstIdx = i;
        break;
      }
    }
 
    if (firstIdx === null) {
      // nothing to accumulate
      return {
        energyConsumptionInKWh: "0.00",
        totalGHGEmission: "0.00",
        quantifiedGHGEmissionsInBaselineScenario: "0.00",
      };
    }
 
    // helper to convert a timestamp (BigNumber/number/string) to seconds (number)
    function toSeconds(ts: any): number | null {
      if (ts === undefined || ts === null) return null;
      let n: number;
      try {
        if (typeof ts === "object" && typeof ts.toNumber === "function") {
          n = ts.toNumber();
        } else {
          n = Number(ts);
        }
      } catch (e) {
        return null;
      }
      if (Number.isNaN(n)) return null;
      if (n > 1e12) return Math.floor(n / 1000);
      return Math.floor(n);
    }
 
    const startTs = toSeconds(
      eventTimestamps[firstIdx] ??
        emissionData[firstIdx].timestamp ??
        emissionData[firstIdx].issuedTime ??
        null
    );
    if (startTs === null) {
      // can't determine start time; return zeros
      return {
        energyConsumptionInKWh: "0.00",
        totalGHGEmission: "0.00",
        quantifiedGHGEmissionsInBaselineScenario: "0.00",
        facilityCapacity: "0.00",
        rangeStartDate: null,
        rangeEndDate: null,
        reportingPeriod: null,
        facilityName: null,
      };
    }
 
    const windowSeconds = 90 * 24 * 60 * 60; // 90 days
    const windowEnd = startTs + windowSeconds;
 
    // use BigInt sums to avoid precision loss (ethers v6 uses BigInt instead of BigNumber)
// use BigInt sums to avoid precision loss (ethers v6 uses BigInt instead of BigNumber)
let energySum = BigInt(0);
let totalGHGSum = BigInt(0);
let quantifiedGHGSum = BigInt(0);
 
    for (let i = 0; i < emissionData.length; i++) {
      const emission: any = emissionData[i];
      if (emission.isVerified) continue;
 
      const ts = toSeconds(
        eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null
      );
      if (ts === null) continue;
      if (ts < startTs || ts > windowEnd) continue;
 
      // emission fields are uint256 (wei-like) so sum them as BigInt
      try {
        energySum += BigInt(emission.energyConsumptionInKWh);
      } catch (e) {
        // if conversion fails, skip
        continue;
      }
      try {
        totalGHGSum += BigInt(emission.totalGHGEmission);
      } catch (e) {
        continue;
      }
      try {
        quantifiedGHGSum += BigInt(emission.quantifiedGHGEmissionsInBaselineScenario);
      } catch (e) {
        continue;
      }
    }
 
    // retrieve facility capacity and plant name/reportingPeriod
    let facilityCapacityFormatted = "0.00";
    let facilityName: string | null = null;
    let reportingPeriod: string | null = null;
 
    try {
      const plantInfoRaw = await basicGreenContractInstance.plantInfo(
        plantAddress
      );
      facilityName = plantInfoRaw.organizationName || null;
    } catch (e) {
      facilityName = null;
    }
 
    try {
      const allEmissionVals =
        await basicGreenContractInstance.allEmissionValues(plantAddress);
      // format facilityCapacity if present
      try {
        // Primary: expect a BigInt-like value (wei-style) and format it
        let capFormatted = "0.00";
        try {
          capFormatted = Number(
            ethers.formatEther(allEmissionVals.facilityCapacity)
          ).toFixed(2);
        } catch (innerErr) {
          // If it's not BigInt-like, maybe it's already a human-readable string/number
          if (
            allEmissionVals.facilityCapacity !== undefined &&
            allEmissionVals.facilityCapacity !== null
          ) {
            const asNum = Number(allEmissionVals.facilityCapacity);
            if (!Number.isNaN(asNum) && asNum !== 0) {
              capFormatted = asNum.toFixed(2);
            } else {
              capFormatted = "0.00";
            }
          }
        }
        facilityCapacityFormatted = capFormatted;
      } catch (e) {
        facilityCapacityFormatted = "0.00";
      }
    } catch (e) {
      facilityCapacityFormatted = "0.00";
    }
 
    // If aggregated facilityCapacity is still zero, try falling back to the
    // per-emission capacity stored on the first unverified emission (if present).
    if (facilityCapacityFormatted === "0.00") {
      try {
        const perEmissionCap = emissionData[firstIdx].facilityCapacity;
        if (perEmissionCap !== undefined && perEmissionCap !== null) {
          facilityCapacityFormatted = Number(
            ethers.formatEther(perEmissionCap)
          ).toFixed(2);
        }
      } catch (e) {
        // keep as "0.00" if fallback fails
      }
    }
 
    // reportingPeriod from first unverified emission (if exists)
    reportingPeriod = emissionData[firstIdx].reportingPeriod ?? null;
 
 const rangeStartDate = formatDate(new Date(startTs * 1000));
const rangeEndDate = formatDate(new Date(windowEnd * 1000));
 
function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
 
  return `${day}/${month}/${year}`;
}
 
 
 
    return {
      energyConsumptionInKWh: Number(
        ethers.formatEther(energySum)
      ).toFixed(2),
      totalGHGEmission: Number(ethers.formatEther(totalGHGSum)).toFixed(2),
      quantifiedGHGEmissionsInBaselineScenario: Number(
        ethers.formatEther(quantifiedGHGSum)
      ).toFixed(2),
      facilityCapacity: facilityCapacityFormatted,
      rangeStartDate,
      rangeEndDate,
      reportingPeriod,
      facilityName,
    };
  } catch (error: any) {
    console.error("Error getting 3-month unverified accumulations:", error);
    return {
      error: error.message || "Unknown error occurred",
    };
  }
}
 
 
 
 
 
 
 
 
async function allEmissionValues(address: string) {
  const { basicGreenContractInstance } = await getContracts();
  const allEmissionValues = await basicGreenContractInstance.allEmissionValues(
    address
  );
  return {
    reportingPeriod: allEmissionValues.reportingPeriod,
    energyConsumptionInKWh: ethers.formatEther(
      allEmissionValues.energyConsumptionInKWh.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      allEmissionValues.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    totalGHGEmission: ethers.formatEther(
      allEmissionValues.totalGHGEmission.toString()
    ),
    isVerified: allEmissionValues.isVerified,
  };
}
 
async function getAllUserEmissionLength(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const allUserEmissionLength =
    await basicGreenContractInstance.getAllUserEmissionLength(address);
  return {
    allUserEmissionLength: ethers.formatEther(
      allUserEmissionLength.toString()
    ),
  };
}


async function dynamicAttributes(address: string, index: number) {
  const { basicGreenContractInstance } = await getContracts();
 
  const dynamicAttributes =
    await basicGreenContractInstance.dynamicAttributes(address, index);
    const conditions = await basicGreenContractInstance.conditions(
      address,
      index
    );
  return {
    energyConsumptionInKWh: ethers.formatEther(
      dynamicAttributes.energyConsumptionInKWh.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      dynamicAttributes.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    reportingPeriod: dynamicAttributes.reportingPeriod,
    totalGHGEmission: ethers.formatEther(
      dynamicAttributes.totalGHGEmission.toString()
    ),
    isValidated: conditions.isValidated,
    isVerified: conditions.isVerified,
    isRejected: conditions.isRejected,
    isCarbonCreditIssued: conditions.isCarbonCreditIssued,
  };
}
 
async function staticPlantAttributes(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const staticPlantAttributes =
    await basicGreenContractInstance.staticPlantAttributes(address);
  // console.log(staticPlantAttributes);
  return {
    OrganizationDescription: staticPlantAttributes.organizationDescription,
    location: staticPlantAttributes.location,
    personResponsible: staticPlantAttributes.personResponsible,
    descriptionOfRenewableEnergySources:
      staticPlantAttributes.descriptionOfRenewableEnergySources,
    baseline: ethers.formatEther(
      staticPlantAttributes.baseline.toString()
    ),
  };
}
 
async function getStaticAttributes(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const staticAttributes =
    await basicGreenContractInstance.getStaticAttributes(address);
  return {
    staticAttributes,
  };
}
 
 
async function carbonCredits(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const carbonCredits = await basicGreenContractInstance.carbonCredits(
    address
  );
  return {
    carbonCredits: ethers.formatEther(carbonCredits.toString()),
  };
}
 
async function isPlantRecorded(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const isRecorded = await basicGreenContractInstance.isPlantRecorded(
    address
  );
  return {
    isRecorded,
  };
}
 
async function plantInfo(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const plantInfo = await basicGreenContractInstance.plantInfo(address);
  return {
    name: plantInfo.name,
    scenario: plantInfo.scenario,
  };
}
 
async function getAllPlantsLength() {
  const { basicGreenContractInstance } = await getContracts();
 
  const allPlantsLength = await basicGreenContractInstance.getAllPlantsLength();
  return {
    allPlantsLength: ethers.formatEther(allPlantsLength.toString()),
  };
}
 
async function getPlantEmissionData(address: string) {
  const { basicGreenContractInstance } = await getContracts();
 
  const plantEmissionData =
    await basicGreenContractInstance.getPlantEmissionData(address);
  return {
    plantEmissionData,
  };
}


// async function getAllEmissionDataWithInfo(): Promise<any[]> {
//   const { basicGreenContractInstance } = await getContracts();
 
//   const allPlantsLength: number = await basicGreenContractInstance.getAllPlantsLength();
//   const result: any[] = [];
 
//   for (let i = 0; i < allPlantsLength; i++) {
//     const plantAddress: string = await basicGreenContractInstance.allPlants(i);
 
//     // Get plant emission data
//     const emissionData: any[] = await basicGreenContractInstance.getPlantEmissionData(
//       plantAddress
//     );
 
//     // Get plant conditions
//     const conditions: any[] = [];
 
//     for (let j = 0; j < emissionData.length; j++) {
//       const condition = await basicGreenContractInstance.conditions(
//         plantAddress,
//         j
//       );
//       // console.log(condition);
//       conditions.push({
//         isValidated: condition.isValidated,
//         isVerified: condition.isVerified,
//         isRejected: condition.isRejected,
//         isCarbonCreditIssued: condition.isCarbonCreditIssued,
//       });
//     }
 
//     // Get plant info
//     const plantInfo: any = await basicGreenContractInstance.plantInfo(plantAddress);
 
//     // Combine emission data, conditions, and plant info
//     const combinedData = { emissionData, conditions, plantInfo };
//     result.push(combinedData);
//   }
 
//   return result;
// }
 
async function getAllPlantsData() {
  const { basicGreenContractInstance } = await getContracts();
 
  const getAllInfo =
    await basicGreenContractInstance.getAllPlantsData();
    return {
      getAllInfo,
    };
}
async function getPlantsData(start: number, count: number) {
  const { basicGreenContractInstance } = await getContracts();
 
  const getAllInfo =
    await basicGreenContractInstance.getPlantsData(start, count);
    return {
      getAllInfo,
    };
}
async function getAllEmissionData() {
  const { basicGreenContractInstance } = await getContracts();
  const allPlantsLength = await basicGreenContractInstance.getAllPlantsLength();
  const allEmissionData = [];
 
  for (let i = 0; i < allPlantsLength; i++) {
    const plantAddress = await basicGreenContractInstance.allPlants(i);
    const plantEmissionData = await basicGreenContractInstance.getPlantEmissionData(plantAddress);
 
    // Get plant conditions
    const conditions = [];
    for (let j = 0; j < plantEmissionData.length; j++) {
      const condition = await basicGreenContractInstance.conditions(plantAddress, j);
      conditions.push({
        isValidated: condition.isValidated,
        isVerified: condition.isVerified,
        isRejected: condition.isRejected,
        isCarbonCreditIssued: condition.isCarbonCreditIssued,
      });
    }
 
    // Get plant info
    const plantInfo = await basicGreenContractInstance.plantInfo(plantAddress);
 
    allEmissionData.push({
      plantAddress,
      emissionData: plantEmissionData,
      conditions: conditions,
      plantInfo: plantInfo,
    });
  }
 
  return allEmissionData;
}




async function getAllPlantEmissionLength(address: string) {
  const { basicGreenContractInstance } = await getContracts();
  const allPlantEmissionLength =
    await basicGreenContractInstance.getAllPlantEmissionLength(address);
  return {
    allPlantEmissionLength: ethers.formatEther(
      allPlantEmissionLength.toString()
    ),
  };
}
 
async function balanceOf(address: string) {
  const { closeCarbonTokenContractInstance } = await getContracts();
  const balance = await closeCarbonTokenContractInstance.balanceOf(address);
  return balance;
}
 
async function burn(
  amountToBurn: number
) {
  const { signer, closeCarbonTokenContractInstance } = await getContracts();
 
  const txKYC = await closeCarbonTokenContractInstance.burn(amountToBurn);
  return {
    txKYC,
  };
}
// new 2026 july

function toSecondsShared(ts: any): number | null {
  if (ts === undefined || ts === null) return null;
  let n: number;
  try {
    if (typeof ts === 'bigint') {
      // v6 bigint
      n = Number(ts);
    } else if (typeof ts === 'object' && ts !== null && 'toNumber' in ts) {
      // v5 BigNumber fallback
      n = ts.toNumber();
    } else {
      n = Number(ts);
    }
  } catch (e) {
    return null;
  }
  if (Number.isNaN(n)) return null;
  // If timestamp is in milliseconds, convert to seconds
  if (n > 1e12) return Math.floor(n / 1000);
  return Math.floor(n);
}

/**
 * Helper function to format ether values safely (v6 compatible)
 */
function formatEtherSafe(value: any, decimals: number = 2): string {
  if (value === undefined || value === null) return "0.00";
  try {
    // In ethers v6, formatEther is a top-level function
    const formatted = ethers.formatEther(value);
    return Number(formatted).toFixed(decimals);
  } catch (e) {
    try {
      const asNum = Number(value);
      if (!Number.isNaN(asNum) && asNum !== 0) {
        return asNum.toFixed(decimals);
      }
    } catch (inner) {}
    return "0.00";
  }
}

/**
 * Helper function to format date
 */
function formatDate(d: Date): string {
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Helper function to build 3-month cards
 */
function buildThreeMonthCards(
  entries: { ts: number; emission: any }[],
  defaultCapacityFormatted: string,
  facilityName: string | null
): any[] {
  if (entries.length === 0) return [];

  const windowSeconds = 90 * 24 * 60 * 60;
  const cards: any[] = [];

  let cardStartTs = entries[0].ts;
  let cardEndTs = cardStartTs + windowSeconds;
  let energySum = BigInt(0);
  let totalGHGSum = BigInt(0);
  let quantifiedGHGSum = BigInt(0);
  let cardReportingPeriod: string | null = entries[0].emission.reportingPeriod ?? null;
  let cardFirstEntry = entries[0];

  const flushCard = () => {
    if (energySum === BigInt(0) && totalGHGSum === BigInt(0) && quantifiedGHGSum === BigInt(0)) {
      return;
    }

    let capacityForCard = defaultCapacityFormatted;
    if (capacityForCard === "0.00") {
      try {
        const perEmissionCap = cardFirstEntry.emission.facilityCapacity;
        if (perEmissionCap !== undefined && perEmissionCap !== null) {
          capacityForCard = Number(ethers.formatEther(perEmissionCap)).toFixed(2);
        }
      } catch (e) {}
    }

    cards.push({
      energyConsumptionInKWh: Number(ethers.formatEther(energySum)).toFixed(2),
      totalGHGEmission: Number(ethers.formatEther(totalGHGSum)).toFixed(2),
      quantifiedGHGEmissionsInBaselineScenario: Number(
        ethers.formatEther(quantifiedGHGSum)
      ).toFixed(2),
      facilityCapacity: capacityForCard,
      rangeStartDate: formatDate(new Date(cardStartTs * 1000)),
      rangeEndDate: formatDate(new Date(cardEndTs * 1000)),
      reportingPeriod: cardReportingPeriod,
      facilityName,
    });
  };

  const addToSum = (value: any, sum: bigint): bigint => {
    if (value === undefined || value === null) return sum;
    try {
      return sum + BigInt(value);
    } catch (e) {
      try {
        return sum + BigInt(String(value));
      } catch (inner) {
        return sum;
      }
    }
  };

  for (const entry of entries) {
    const { ts, emission } = entry;

    if (ts > cardEndTs) {
      flushCard();
      cardStartTs = ts;
      cardEndTs = cardStartTs + windowSeconds;
      energySum = BigInt(0);
      totalGHGSum = BigInt(0);
      quantifiedGHGSum = BigInt(0);
      cardReportingPeriod = emission.reportingPeriod ?? null;
      cardFirstEntry = entry;
    }

    energySum = addToSum(emission.energyConsumptionInKWh, energySum);
    totalGHGSum = addToSum(emission.totalGHGEmission, totalGHGSum);
    quantifiedGHGSum = addToSum(
      emission.quantifiedGHGEmissionsInBaselineScenario,
      quantifiedGHGSum
    );
  }

  flushCard();
  return cards;
}
 
export async function getThreeMonthUnverifiedAccumulationCardsForPlant(
  plantAddress: string,
) {
  try {
    const { basicGreenContractInstance } = await getContracts();

    // Independent reads run concurrently instead of one-after-another.
    const [emissionData, eventTimestamps, plantInfoRaw, allEmissionVals] =
      await Promise.all([
        basicGreenContractInstance.getPlantEmissionData(plantAddress),
        getPlantRecordedTimestamps(basicGreenContractInstance, plantAddress),
        basicGreenContractInstance
          .plantInfo(plantAddress)
          .catch(() => null),
        basicGreenContractInstance
          .allEmissionValues(plantAddress)
          .catch(() => null),
      ]);

    const facilityName: string | null = plantInfoRaw?.organizationName || null;
    const defaultCapacityFormatted = formatEtherSafe(
      allEmissionVals?.facilityCapacity,
      2,
    );

    type Entry = { ts: number; emission: any };
    const entries: Entry[] = [];
    let undatedCount = 0;
    for (let i = 0; i < emissionData.length; i++) {
      const emission: any = emissionData[i];
      if (emission.isVerified) continue;
      const ts = toSecondsShared(eventTimestamps[i] ?? null);
      if (ts === null) {
        undatedCount++;
        continue;
      }
      entries.push({ ts, emission });
    }

    if (undatedCount > 0) {
      console.warn(
        `getThreeMonthUnverifiedAccumulationCardsForPlant: ${undatedCount} unverified emission(s) for ${plantAddress} have no resolvable timestamp and were excluded from any card`,
      );
    }

    if (entries.length === 0) {
      return [];
    }

    entries.sort((a, b) => a.ts - b.ts);

    return buildThreeMonthCards(entries, defaultCapacityFormatted, facilityName);
  } catch (error: any) {
    console.error(
      "Error getting 3-month unverified accumulation cards:",
      error,
    );
    return {
      error: error.message || "Unknown error occurred",
    };
  }
}

/**
 * Get 3-month cards for all plants in parallel
 */
 async function getAllPlantsThreeMonthCards() {
  try {
    const { basicGreenContractInstance } = await getContracts();

    const totalPlants = await basicGreenContractInstance.getAllPlantsLength();
    // Handle both v5 (toNumber) and v6 (bigint)
    const total = typeof totalPlants === 'bigint' 
      ? Number(totalPlants) 
      : totalPlants.toNumber ? totalPlants.toNumber() : Number(totalPlants);

    if (total === 0) return [];

    const plantsData = await basicGreenContractInstance.getPlantsData(
      0,
      total,
    );

    const candidates = plantsData.filter(
      (p: any) => p.isPlantRecorded && !p.isVerified,
    );

    if (candidates.length === 0) return [];

    const allEvents = await getPlantRecordedEvents(basicGreenContractInstance);

    const perPlantResults = await Promise.all(
      candidates.map(async (plantData: any) => {
        try {
          const plantAddress: string = plantData.plantAddress;

          const emissionData =
            await basicGreenContractInstance.getPlantEmissionData(
              plantAddress,
            );

          const eventTimestamps = allEvents
            .filter(
              (e) => e.plant.toLowerCase() === plantAddress.toLowerCase(),
            )
            .sort(
              (a, b) =>
                a.blockNumber - b.blockNumber || a.logIndex - b.logIndex,
            )
            .map((e) => e.timestamp);

          type Entry = { ts: number; emission: any };
          const entries: Entry[] = [];
          let undatedCount = 0;
          for (let j = 0; j < emissionData.length; j++) {
            const emission: any = emissionData[j];
            if (emission.isVerified) continue;
            const ts = toSecondsShared(eventTimestamps[j] ?? null);
            if (ts === null) {
              undatedCount++;
              continue;
            }
            entries.push({ ts, emission });
          }

          if (undatedCount > 0) {
            console.warn(
              `getAllPlantsThreeMonthCards: ${undatedCount} unverified emission(s) for ${plantAddress} have no resolvable timestamp and were excluded from any card`,
            );
          }

          if (entries.length === 0) return null;

          entries.sort((a, b) => a.ts - b.ts);

          const facilityName = plantData.organizationName || null;
          const defaultCapacityFormatted = formatEtherSafe(
            plantData.emissionData?.facilityCapacity,
            2,
          );

          const cards = buildThreeMonthCards(
            entries,
            defaultCapacityFormatted,
            facilityName,
          );

          if (cards.length === 0) return null;
          return { plantAddress, cards };
        } catch (error: any) {
          console.warn(
            `getAllPlantsThreeMonthCards: Failed to process plant ${plantData.plantAddress}:`,
            error.message
          );
          return null;
        }
      }),
    );

    const successfulResults = perPlantResults.filter(
      (r): r is { plantAddress: string; cards: any[] } => r !== null,
    );

    if (successfulResults.length < candidates.length) {
      console.warn(
        `getAllPlantsThreeMonthCards: ${candidates.length - successfulResults.length} plant(s) failed to process`
      );
    }

    return successfulResults;
  } catch (error: any) {
    console.error("Error getting all plants 3-month cards:", error);
    return [];
  }
}

//  Get 3-month unverified accumulation cards for a single plant

//  async function getThreeMonthUnverifiedAccumulationCardsForPlant(
//   plantAddress: string,
// ) {
//   try {
//     const { basicGreenContractInstance } = await getContracts();

//     // Independent reads run concurrently instead of one-after-another.
//     const [emissionData, eventTimestamps, plantInfoRaw, allEmissionVals] =
//       await Promise.all([
//         basicGreenContractInstance.getPlantEmissionData(plantAddress),
//         getPlantRecordedTimestamps(basicGreenContractInstance, plantAddress),
//         basicGreenContractInstance
//           .plantInfo(plantAddress)
//           .catch(() => null),
//         basicGreenContractInstance
//           .allEmissionValues(plantAddress)
//           .catch(() => null),
//       ]);

//     const facilityName: string | null = plantInfoRaw?.organizationName || null;
//     const defaultCapacityFormatted = formatEtherSafe(
//       allEmissionVals?.facilityCapacity,
//       2,
//     );

//     type Entry = { ts: number; emission: any };
//     const entries: Entry[] = [];
//     let undatedCount = 0;
//     for (let i = 0; i < emissionData.length; i++) {
//       const emission: any = emissionData[i];
//       if (emission.isVerified) continue;
//       const ts = toSecondsShared(eventTimestamps[i] ?? null);
//       if (ts === null) {
//         undatedCount++;
//         continue;
//       }
//       entries.push({ ts, emission });
//     }

//     if (undatedCount > 0) {
//       console.warn(
//         `getThreeMonthUnverifiedAccumulationCardsForPlant: ${undatedCount} unverified emission(s) for ${plantAddress} have no resolvable timestamp and were excluded from any card`,
//       );
//     }

//     if (entries.length === 0) {
//       return [];
//     }

//     entries.sort((a, b) => a.ts - b.ts);

//     return buildThreeMonthCards(entries, defaultCapacityFormatted, facilityName);
//   } catch (error: any) {
//     console.error(
//       "Error getting 3-month unverified accumulation cards:",
//       error,
//     );
//     return {
//       error: error.message || "Unknown error occurred",
//     };
//   }
// }

/**
 * Get 3-month cards for all plants in parallel
 */
//  async function getAllPlantsThreeMonthCards() {
//   try {
//     const { basicGreenContractInstance } = await getContracts();

//     const totalPlants = await basicGreenContractInstance.getAllPlantsLength();
//     // Handle both v5 (toNumber) and v6 (bigint)
//     const total = typeof totalPlants === 'bigint' 
//       ? Number(totalPlants) 
//       : totalPlants.toNumber ? totalPlants.toNumber() : Number(totalPlants);

//     if (total === 0) return [];

//     const plantsData = await basicGreenContractInstance.getPlantsData(
//       0,
//       total,
//     );

//     const candidates = plantsData.filter(
//       (p: any) => p.isPlantRecorded && !p.isVerified,
//     );

//     if (candidates.length === 0) return [];

//     const allEvents = await getPlantRecordedEvents(basicGreenContractInstance);

//     const perPlantResults = await Promise.all(
//       candidates.map(async (plantData: any) => {
//         try {
//           const plantAddress: string = plantData.plantAddress;

//           const emissionData =
//             await basicGreenContractInstance.getPlantEmissionData(
//               plantAddress,
//             );

//           const eventTimestamps = allEvents
//             .filter(
//               (e) => e.plant.toLowerCase() === plantAddress.toLowerCase(),
//             )
//             .sort(
//               (a, b) =>
//                 a.blockNumber - b.blockNumber || a.logIndex - b.logIndex,
//             )
//             .map((e) => e.timestamp);

//           type Entry = { ts: number; emission: any };
//           const entries: Entry[] = [];
//           let undatedCount = 0;
//           for (let j = 0; j < emissionData.length; j++) {
//             const emission: any = emissionData[j];
//             if (emission.isVerified) continue;
//             const ts = toSecondsShared(eventTimestamps[j] ?? null);
//             if (ts === null) {
//               undatedCount++;
//               continue;
//             }
//             entries.push({ ts, emission });
//           }

//           if (undatedCount > 0) {
//             console.warn(
//               `getAllPlantsThreeMonthCards: ${undatedCount} unverified emission(s) for ${plantAddress} have no resolvable timestamp and were excluded from any card`,
//             );
//           }

//           if (entries.length === 0) return null;

//           entries.sort((a, b) => a.ts - b.ts);

//           const facilityName = plantData.organizationName || null;
//           const defaultCapacityFormatted = formatEtherSafe(
//             plantData.emissionData?.facilityCapacity,
//             2,
//           );

//           const cards = buildThreeMonthCards(
//             entries,
//             defaultCapacityFormatted,
//             facilityName,
//           );

//           if (cards.length === 0) return null;
//           return { plantAddress, cards };
//         } catch (error: any) {
//           console.warn(
//             `getAllPlantsThreeMonthCards: Failed to process plant ${plantData.plantAddress}:`,
//             error.message
//           );
//           return null;
//         }
//       }),
//     );

//     const successfulResults = perPlantResults.filter(
//       (r): r is { plantAddress: string; cards: any[] } => r !== null,
//     );

//     if (successfulResults.length < candidates.length) {
//       console.warn(
//         `getAllPlantsThreeMonthCards: ${candidates.length - successfulResults.length} plant(s) failed to process`
//       );
//     }

//     return successfulResults;
//   } catch (error: any) {
//     console.error("Error getting all plants 3-month cards:", error);
//     return [];
//   }
// }
// async function getAllPlantsThreeMonthCards() {
//   try {
//     const { basicGreenContractInstance } = await getContracts();

//     // Helper function to convert timestamp to seconds
//     function toSecondsShared(ts: any): number | null {
//       if (ts === undefined || ts === null) return null;
//       let n: number;
//       try {
//         if (typeof ts === 'object' && typeof ts.toNumber === 'function') {
//           // v5 BigNumber fallback
//           n = ts.toNumber();
//         } else if (typeof ts === 'bigint') {
//           // v6 bigint
//           n = Number(ts);
//         } else {
//           n = Number(ts);
//         }
//       } catch (e) {
//         return null;
//       }
//       if (Number.isNaN(n)) return null;
//       // If timestamp is in milliseconds, convert to seconds
//       if (n > 1e12) return Math.floor(n / 1000);
//       return Math.floor(n);
//     }

//     // Helper function to format ether values safely
//     function formatEtherSafe(value: any, decimals: number = 2): string {
//       if (value === undefined || value === null) return "0.00";
//       try {
//         // In ethers v6, formatEther is a top-level function
//         const formatted = ethers.formatEther(value);
//         return Number(formatted).toFixed(decimals);
//       } catch (e) {
//         try {
//           const asNum = Number(value);
//           if (!Number.isNaN(asNum) && asNum !== 0) {
//             return asNum.toFixed(decimals);
//           }
//         } catch (inner) {}
//         return "0.00";
//       }
//     }

//     // Helper function to format date
//     function formatDate(d: Date): string {
//       const year = d.getUTCFullYear();
//       const month = String(d.getUTCMonth() + 1).padStart(2, "0");
//       const day = String(d.getUTCDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     }

//     // Helper function to build 3-month cards
//     function buildThreeMonthCards(
//       entries: { ts: number; emission: any }[],
//       defaultCapacityFormatted: string,
//       facilityName: string | null
//     ): any[] {
//       if (entries.length === 0) return [];

//       const windowSeconds = 90 * 24 * 60 * 60;
//       const cards: any[] = [];

//       let cardStartTs = entries[0].ts;
//       let cardEndTs = cardStartTs + windowSeconds;
//       let energySum = BigInt(0);
//       let totalGHGSum = BigInt(0);
//       let quantifiedGHGSum = BigInt(0);
//       let cardReportingPeriod: string | null = entries[0].emission.reportingPeriod ?? null;
//       let cardFirstEntry = entries[0];

//       const flushCard = () => {
//         if (energySum === BigInt(0) && totalGHGSum === BigInt(0) && quantifiedGHGSum === BigInt(0)) {
//           return;
//         }

//         let capacityForCard = defaultCapacityFormatted;
//         if (capacityForCard === "0.00") {
//           try {
//             const perEmissionCap = cardFirstEntry.emission.facilityCapacity;
//             if (perEmissionCap !== undefined && perEmissionCap !== null) {
//               capacityForCard = Number(ethers.formatEther(perEmissionCap)).toFixed(2);
//             }
//           } catch (e) {}
//         }

//         cards.push({
//           energyConsumptionInKWh: Number(ethers.formatEther(energySum)).toFixed(2),
//           totalGHGEmission: Number(ethers.formatEther(totalGHGSum)).toFixed(2),
//           quantifiedGHGEmissionsInBaselineScenario: Number(
//             ethers.formatEther(quantifiedGHGSum)
//           ).toFixed(2),
//           facilityCapacity: capacityForCard,
//           rangeStartDate: formatDate(new Date(cardStartTs * 1000)),
//           rangeEndDate: formatDate(new Date(cardEndTs * 1000)),
//           reportingPeriod: cardReportingPeriod,
//           facilityName,
//         });
//       };

//       const addToSum = (value: any, sum: bigint): bigint => {
//         if (value === undefined || value === null) return sum;
//         try {
//           return sum + BigInt(value);
//         } catch (e) {
//           try {
//             return sum + BigInt(String(value));
//           } catch (inner) {
//             return sum;
//           }
//         }
//       };

//       for (const entry of entries) {
//         const { ts, emission } = entry;

//         if (ts > cardEndTs) {
//           flushCard();
//           cardStartTs = ts;
//           cardEndTs = cardStartTs + windowSeconds;
//           energySum = BigInt(0);
//           totalGHGSum = BigInt(0);
//           quantifiedGHGSum = BigInt(0);
//           cardReportingPeriod = emission.reportingPeriod ?? null;
//           cardFirstEntry = entry;
//         }

//         energySum = addToSum(emission.energyConsumptionInKWh, energySum);
//         totalGHGSum = addToSum(emission.totalGHGEmission, totalGHGSum);
//         quantifiedGHGSum = addToSum(
//           emission.quantifiedGHGEmissionsInBaselineScenario,
//           quantifiedGHGSum
//         );
//       }

//       flushCard();
//       return cards;
//     }

//     // Get total plants count
//     const totalPlants = await basicGreenContractInstance.getAllPlantsLength();
//     const total = totalPlants.toNumber
//       ? totalPlants.toNumber()
//       : Number(totalPlants);

//     if (total === 0) return [];

//     // Get all plants data in one call
//     const plantsData = await basicGreenContractInstance.getPlantsData(0, total);

//     // Filter for recorded but unverified plants
//     const candidates = plantsData.filter(
//       (p: any) => p.isPlantRecorded && !p.isVerified,
//     );

//     if (candidates.length === 0) return [];

//     // Get all events once - shared across all plants
//     const allEvents = await getPlantRecordedEvents(basicGreenContractInstance);

//     // Process all candidates in parallel
//     const perPlantResults = await Promise.all(
//       candidates.map(async (plantData: any) => {
//         try {
//           const plantAddress: string = plantData.plantAddress;

//           // Fetch emission data for this plant
//           const emissionData = await basicGreenContractInstance.getPlantEmissionData(
//             plantAddress,
//           );

//           // Get timestamps specific to this plant from shared events
//           const eventTimestamps = allEvents
//             .filter(
//               (e) => e.plant.toLowerCase() === plantAddress.toLowerCase(),
//             )
//             .sort(
//               (a, b) =>
//                 a.blockNumber - b.blockNumber || a.logIndex - b.logIndex,
//             )
//             .map((e) => e.timestamp);

//           // Build entries from unverified emissions
//           type Entry = { ts: number; emission: any };
//           const entries: Entry[] = [];
//           let undatedCount = 0;
          
//           for (let j = 0; j < emissionData.length; j++) {
//             const emission: any = emissionData[j];
//             if (emission.isVerified) continue;
            
//             const ts = toSecondsShared(eventTimestamps[j] ?? null);
//             if (ts === null) {
//               undatedCount++;
//               continue;
//             }
//             entries.push({ ts, emission });
//           }

//           if (undatedCount > 0) {
//             console.warn(
//               `getAllPlantsThreeMonthCards: ${undatedCount} unverified emission(s) for ${plantAddress} have no resolvable timestamp and were excluded from any card`,
//             );
//           }

//           if (entries.length === 0) return null;

//           // Sort entries chronologically
//           entries.sort((a, b) => a.ts - b.ts);

//           // Get plant metadata
//           const facilityName = plantData.organizationName || null;
//           const defaultCapacityFormatted = formatEtherSafe(
//             plantData.emissionData?.facilityCapacity,
//             2,
//           );

//           // Build 3-month cards
//           const cards = buildThreeMonthCards(
//             entries,
//             defaultCapacityFormatted,
//             facilityName,
//           );

//           if (cards.length === 0) return null;
          
//           return { plantAddress, cards };
//         } catch (error: any) {
//           console.warn(
//             `getAllPlantsThreeMonthCards: Failed to process plant ${plantData.plantAddress}:`,
//             error.message
//           );
//           return null;
//         }
//       }),
//     );

//     // Filter out failed plants
//     const successfulResults = perPlantResults.filter(
//       (r): r is { plantAddress: string; cards: any[] } => r !== null,
//     );

//     if (successfulResults.length < candidates.length) {
//       console.warn(
//         `getAllPlantsThreeMonthCards: ${candidates.length - successfulResults.length} plant(s) failed to process`
//       );
//     }

//     return successfulResults;
//   } catch (error: any) {
//     console.error("Error getting all plants 3-month cards:", error);
//     return [];
//   }
// }
// async function getAllPlantsThreeMonthCards() {
//   try {
//     const { basicGreenContractInstance } = await getContracts();

//     const totalPlants = await basicGreenContractInstance.getAllPlantsLength();
//     // In v6, contract calls return bigint for uint; convert to number safely.
//     const total = typeof totalPlants === 'bigint' ? Number(totalPlants) : Number(totalPlants);

//     if (total === 0) return [];

//     const results: any[] = [];

//     for (let i = 0; i < total; i++) {
//       const plantAddress = await basicGreenContractInstance.allPlants(i);

//       const emissionData =
//         await basicGreenContractInstance.getPlantEmissionData(plantAddress);

//       let eventTimestamps: any[] = [];
//       try {
//         const filter =
//           basicGreenContractInstance.filters.PlantRecorded(plantAddress);
//         const events = await basicGreenContractInstance.queryFilter(filter);
//         events.sort((a: any, b: any) => {
//           if (a.blockNumber !== b.blockNumber)
//             return a.blockNumber - b.blockNumber;
//           return a.logIndex - b.logIndex;
//         });
//         eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
//       } catch (e) {
//         eventTimestamps = [];
//       }

//       function toSeconds(ts: any): number | null {
//         if (ts === undefined || ts === null) return null;
//         let n: number;
//         try {
//           if (typeof ts === 'object' && typeof ts.toNumber === 'function') {
//             // v5 BigNumber fallback
//             n = ts.toNumber();
//           } else if (typeof ts === 'bigint') {
//             // v6 bigint
//             n = Number(ts);
//           } else {
//             n = Number(ts);
//           }
//         } catch (e) {
//           return null;
//         }
//         if (Number.isNaN(n)) return null;
//         // If timestamp is in milliseconds, convert to seconds
//         if (n > 1e12) return Math.floor(n / 1000);
//         return Math.floor(n);
//       }

//       type Entry = { idx: number; ts: number; emission: any };
//       const entries: Entry[] = [];
//       for (let j = 0; j < emissionData.length; j++) {
//         const emission: any = emissionData[j];
//         if (emission.isVerified) continue;
//         const ts = toSeconds(
//           eventTimestamps[j] ??
//             emission.timestamp ??
//             emission.issuedTime ??
//             null,
//         );
//         if (ts === null) continue;
//         entries.push({ idx: j, ts, emission });
//       }

//       if (entries.length === 0) continue;

//       entries.sort((a, b) => a.ts - b.ts);

//       // Pre-fetch plant-level metadata
//       let facilityCapacityFormatted = "0.00";
//       let facilityName: string | null = null;

//       try {
//         const plantInfoRaw = await basicGreenContractInstance.plantInfo(
//           plantAddress,
//         );
//         facilityName = plantInfoRaw.organizationName || null;
//       } catch (e) {
//         facilityName = null;
//       }

//       try {
//         const allEmissionVals =
//           await basicGreenContractInstance.allEmissionValues(plantAddress);
//         try {
//           let capFormatted = "0.00";
//           try {
//             capFormatted = Number(
//               ethers.formatEther(allEmissionVals.facilityCapacity)   // v6
//             ).toFixed(2);
//           } catch (innerErr) {
//             if (
//               allEmissionVals.facilityCapacity !== undefined &&
//               allEmissionVals.facilityCapacity !== null
//             ) {
//               const asNum = Number(allEmissionVals.facilityCapacity);
//               if (!Number.isNaN(asNum) && asNum !== 0) {
//                 capFormatted = asNum.toFixed(2);
//               } else {
//                 capFormatted = "0.00";
//               }
//             }
//           }
//           facilityCapacityFormatted = capFormatted;
//         } catch (e) {
//           facilityCapacityFormatted = "0.00";
//         }
//       } catch (e) {
//         facilityCapacityFormatted = "0.00";
//       }

//       function formatDate(d: Date): string {
//         const year = d.getUTCFullYear();
//         const month = String(d.getUTCMonth() + 1).padStart(2, "0");
//         const day = String(d.getUTCDate()).padStart(2, "0");
//         return `${year}-${month}-${day}`;
//       }

//       const windowSeconds = 90 * 24 * 60 * 60;
//       const cards: any[] = [];

//       let cardStartTs = entries[0].ts;
//       let cardEndTs = cardStartTs + windowSeconds;
//       let energySum = BigInt(0);
//       let totalGHGSum = BigInt(0);
//       let quantifiedGHGSum = BigInt(0);
//       let cardReportingPeriod: string | null =
//         entries[0].emission.reportingPeriod ?? null;
//       let cardFirstEntry: Entry = entries[0]; // ✅ track current card's first entry

//       const flushCard = () => {
//         if (energySum === BigInt(0) && totalGHGSum === BigInt(0) && quantifiedGHGSum === BigInt(0)) {
//           return;
//         }

//         let capacityForCard = facilityCapacityFormatted;
//         if (capacityForCard === "0.00") {
//           try {
//             const perEmissionCap = cardFirstEntry.emission.facilityCapacity; // ✅ current card
//             if (perEmissionCap !== undefined && perEmissionCap !== null) {
//               capacityForCard = Number(
//                 ethers.formatEther(perEmissionCap)   // v6
//               ).toFixed(2);
//             }
//           } catch (e) {}
//         }

//         cards.push({
//           energyConsumptionInKWh: Number(
//             ethers.formatEther(energySum)   // v6
//           ).toFixed(2),
//           totalGHGEmission: Number(
//             ethers.formatEther(totalGHGSum)   // v6
//           ).toFixed(2),
//           quantifiedGHGEmissionsInBaselineScenario: Number(
//             ethers.formatEther(quantifiedGHGSum)   // v6
//           ).toFixed(2),
//           facilityCapacity: capacityForCard,
//           rangeStartDate: formatDate(new Date(cardStartTs * 1000)),
//           rangeEndDate: formatDate(new Date(cardEndTs * 1000)),
//           reportingPeriod: cardReportingPeriod,
//           facilityName,
//         });
//       };

//       for (const entry of entries) {
//         const { ts, emission } = entry;

//         if (ts > cardEndTs) {
//           flushCard();
//           cardStartTs = ts;
//           cardEndTs = cardStartTs + windowSeconds;
//           energySum = BigInt(0);
//           totalGHGSum = BigInt(0);
//           quantifiedGHGSum = BigInt(0);
//           cardReportingPeriod = emission.reportingPeriod ?? null;
//           cardFirstEntry = entry; // ✅ reset for new card
//         }

//         const energyVal = emission.energyConsumptionInKWh;
//         if (energyVal !== undefined && energyVal !== null) {
//           try {
//             energySum += BigInt(energyVal);
//           } catch (e) {
//             try {
//               energySum += BigInt(String(energyVal));
//             } catch (inner) {}
//           }
//         }

//         const totalGHVal = emission.totalGHGEmission;
//         if (totalGHVal !== undefined && totalGHVal !== null) {
//           try {
//             totalGHGSum += BigInt(totalGHVal);
//           } catch (e) {
//             try {
//               totalGHGSum += BigInt(String(totalGHVal));
//             } catch (inner) {}
//           }
//         }

//         const quantifiedVal =
//           emission.quantifiedGHGEmissionsInBaselineScenario;
//         if (quantifiedVal !== undefined && quantifiedVal !== null) {
//           try {
//             quantifiedGHGSum += BigInt(quantifiedVal);
//           } catch (e) {
//             try {
//               quantifiedGHGSum += BigInt(String(quantifiedVal));
//             } catch (inner) {}
//           }
//         }
//       }

//       // Flush the last card
//       flushCard();

//       if (cards.length > 0) {
//         results.push({
//           plantAddress,
//           cards,
//         });
//       }
//     }

//     return results;
//   } catch (error: any) {
//     console.error("Error getting all plants 3-month cards:", error);
//     return {
//       error: error.message || "Unknown error occurred",
//     };
//   }
// }
// 

// 
async function getIndividualEmissionsForCard(
  plantAddress: string,
  rangeStartDate: string,
  rangeEndDate: string,
) {
  try {
    const { basicGreenContractInstance } = await getContracts();

    const emissionData = await basicGreenContractInstance.getPlantEmissionData(plantAddress);
      // console.log("EMISSION", emissionData)


    let eventTimestamps: any[] = [];
    try {
      const filter = basicGreenContractInstance.filters.PlantRecorded(plantAddress);
      const events = await basicGreenContractInstance.queryFilter(filter);
      events.sort((a: any, b: any) => {
        if (a.blockNumber !== b.blockNumber) return a.blockNumber - b.blockNumber;
        return a.logIndex - b.logIndex;
      });
      eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
    } catch (e) {
      eventTimestamps = [];
    }

    function toSeconds(ts: any): number | null {
      if (ts === undefined || ts === null) return null;
      let n: number;
      try {
        // Handle ethers v5 BigNumber (with toNumber) and v6 bigint
        if (typeof ts === 'object' && typeof ts.toNumber === 'function') {
          n = ts.toNumber();                // v5 BigNumber
        } else if (typeof ts === 'bigint') {
          n = Number(ts);                   // v6 bigint
        } else {
          n = Number(ts);                    // number or string
        }
      } catch (e) {
        return null;
      }
      if (Number.isNaN(n)) return null;
      // If timestamp is in milliseconds, convert to seconds
      if (n > 1e12) return Math.floor(n / 1000);
      return Math.floor(n);
    }

    function formatDate(d: Date): string {
      const year = d.getUTCFullYear();
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const day = String(d.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    // Snap to start of day for windowStart, end of day for windowEnd
    // to avoid missing emissions due to time-of-day differences
    const windowStart = Math.floor(new Date(rangeStartDate).getTime() / 1000);
    const windowEnd = Math.floor(new Date(rangeEndDate).getTime() / 1000) + 86399;

    const individualEmissions: any[] = [];

    for (let i = 0; i < emissionData.length; i++) {
      const emission: any = emissionData[i];
      if (emission.isVerified) continue;

      const ts = toSeconds(
        eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null,
      );
      if (ts === null) continue;

      if (ts < windowStart || ts > windowEnd) continue;

      individualEmissions.push({
        date: formatDate(new Date(ts * 1000)),
        reportingPeriod: emission.reportingPeriod,
        energyConsumptionInKWh: Number(
          ethers.formatEther(emission.energyConsumptionInKWh)   // ethers v6
        ).toFixed(4),
        totalGHGEmission: Number(
          ethers.formatEther(emission.totalGHGEmission)
        ).toFixed(4),
        quantifiedGHGEmissionsInBaselineScenario: Number(
          ethers.formatEther(emission.quantifiedGHGEmissionsInBaselineScenario)
        ).toFixed(4),
        facilityCapacity: Number(
          ethers.formatEther(emission.facilityCapacity)
        ).toFixed(4),
        isVerified: emission.isVerified,
        facilityName: emission.name,

      });
    }

    // Sort by date ascending so the table renders chronologically
    individualEmissions.sort((a, b) => a.date.localeCompare(b.date));

    return {
      plantAddress,
      rangeStartDate,
      rangeEndDate,
      individualEmissions,
    };
  } catch (error: any) {
    console.error("Error getting individual emissions for card:", error);
    return { error: error.message || "Unknown error occurred" };
  }
}
export {
  // performKYC,
  // recordPlant,
  // rejectValidation,
  getIndividualEmissionsForCard,
  getAllPlantsThreeMonthCards,
  getThreeMonthUnverifiedAccumulationsForPlant,
  getThreeMonthUnverifiedAccumulationsAll,
  
  encodeStaticData,
  encodedDynamicAttributes,
  // encodeGreenIndirectDynamicAttributes,
  pinLinksToIPFS,
  // grantRole,
  // validate,
  // verifyAndMint,
  // issueCarbonCredits,
  getThreeMonthUnverifiedAccumulations,
  getAllEmissionValues,
  userEmission,
  allEmission,
  allEmissionValues,
  dynamicAttributes,
  staticPlantAttributes,
  carbonCredits,
  getPlantEmissionData,
  conditions,
  getAllPlantEmissionLength,
  plantInfo,
  // getAllPlantsData,
  isPlantRecorded,
  getAllUserEmissionLength,
  getAllPlantsLength,
  // getUserEmissions,
  balanceOf,
  getStaticAttributes,
  getPlantsData
};
 
 
getPlantEmissionData("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
  .then((result) => {
    // console.log(result);
  })
  .catch((err) => {
    console.log(err);
  });
 
 
// getAllUserEmissionLength("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// getUserEmissions()
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   }); 

// isPlantRecorded("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
// .then((result) => {
//   console.log(result);
// })
// .catch((err) => {
//   console.log(err);
// });
 
// getAllEmissionDataWithInfo()
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// getAllEmissionData()
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// plantInfo("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// getAllPlantEmissionLength("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// issueCarbonCredits("0x56Fec7a6027603fcaB2867A41eD30a094b05d62A")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// conditions("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538", 0)
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// validate("0x56Fec7a6027603fcaB2867A41eD30a094b05d62A")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// verifyAndMint("0x56Fec7a6027603fcaB2867A41eD30a094b05d62A")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// getAllEmissionData()
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// userEmission("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// performKYC(
//   "0x56Fec7a6027603fcaB2867A41eD30a094b05d62A",
 
//   "0x00000000000000000000000000000000000000000000000000000000000000c000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000140000000000000000000000000000000000000000000000000000000000000018000000000000000000000000000000000000000000000000000000000000001c00000000000000000000000000000000000000000000000000000000000001388000000000000000000000000000000000000000000000000000000000000000b4167726963756c747572650000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005496e6469610000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005526168756c0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003516d5a0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000c536f6c617220456e657267790000000000000000000000000000000000000000",
//   "Agriculture",
//   "Green Project"
// )
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
// recordPlant(
//   ["0x56Fec7a6027603fcaB2867A41eD30a094b05d62A"],
//   [
//     "0x00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000056bc75e2d6310000000000000000000000000000000000000000000000000000ad78ebc5ac620000000000000000000000000000000000000000000000000010f0cf064dd5920000000000000000000000000000000000000000000000000000000000000000000043230323100000000000000000000000000000000000000000000000000000000",
//   ]
// )
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// carbonCredits("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// getAllEmissionValues("0xc06fB8C480B0B7A5a4D96B7822618e8A9C734323")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// staticPlantAttributes("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// grantRole(1, "0xf7de326EF2898962C879DF0e7e5Acc599cF03907")
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// dynamicAttributes("0x9923a33D6Aa8e6De61A3322c5348d3b05966f538", 0)
//   // "0x9923a33D6Aa8e6De61A3322c5348d3b05966f538"
//   .then((result) => {
//     console.log(result);
//   })
//   .catch((err) => {
//     console.log(err);
//   });
 
// encodeStaticData("Agriculture", "India", "Rahul", "QmZ", "Solar Energy", 5000);
// encodedDynamicAttributes("2021", 100, 200, 5000);
 